import type { EventDataNode } from 'rc-tree/lib/interface';

import type { ILocation } from '@model/structureData';

export const getAllChildrenIds = (node: EventDataNode<ILocation>): number[] => {
  const result: number[] = [];

  const traverse = (location: ILocation) => {
    if (!location.children || location.children.length === 0) return;

    for (let i = 0; i < location.children.length; i++) {
      const child = location.children[i];
      result.push(child.id);
      traverse(child);
    }
  };

  traverse(node);

  return result;
};
